import { Tooltip, DefaultLegendContent } from 'recharts';

export function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export function getDate90DaysOut() {
  // 1. Get today's date
  const today = new Date();

  // 2. Create a new date object to avoid modifying the original 'today' variable
  const date90DaysLater = new Date(today);

  // 3. Add 90 days to the new date using setDate() and getDate()
  // setDate() automatically handles month and year rollovers
  date90DaysLater.setDate(today.getDate() + 90);

  // 4. Format the new date as YYYY-MM-DD
  // toISOString() returns a string in the format "YYYY-MM-DDTHH:mm:ss.sssZ" (UTC)
  // .split('T')[0] extracts only the date portion before the 'T'
  const formattedDate = date90DaysLater.toISOString().split('T')[0];

  // 5. Return the formatted date string
  return formattedDate;
}


export function convertDateToShortISOFormat(v) {
    if (!v) {
        return null;
    }
    var tempDate = new Date(v);
    const year = tempDate.getFullYear(),
        month = tempDate.getMonth() + 1,
        day = tempDate.getDate(),
        hour = tempDate.getHours(),
        min = tempDate.getMinutes()
    return `${month}/${day}/${year} - ${hour} : ${min}`;
}

export function convertDate(v) {
    if (!v) {
        return null;
    }
    var tempDate = new Date(v);
    const year = tempDate.getFullYear(),
        month = tempDate.getMonth() + 1,
        day = tempDate.getDate()
    return `${month}/${day}/${year}`;
}

export function timeout(delay) {
    return new Promise(res => setTimeout(res, delay));
}

export function checkEmpty(val) {
    // test results
    //---------------
    // []        true, empty array
    // {}        true, empty object
    // null      true
    // undefined true
    // ""        true, empty string
    // ''        true, empty string
    // 0         false, number
    // true      false, boolean
    // false     false, boolean
    // Date      false
    // function  false

    if (val === undefined || Number.isNaN(val))
        return true;

    if (typeof (val) == 'function' || typeof (val) == 'number' || typeof (val) == 'boolean' || Object.prototype.toString.call(val) === '[object Date]')
        return false;
    if (val == null || val.length === 0)        // null or 0 length array
        return true;
    if (typeof (val) == "object") {
        // empty object
        var r = true;
        for (var f in val)
            r = false;
        return r;
    }
    return false;
}

export function stripOutUserName(str) {
    if (str != null) {
        return str.substring(0, str.lastIndexOf('@'));
    }
    else {
        return str;
    }
}

export function tableToCSV() {
    let csv_data = [];
    let dataTable = document.getElementById("dataTable");
    let rows = dataTable.getElementsByTagName('tr');
    for (let i = 0; i < rows.length; i++) {
        let cols = rows[i].querySelectorAll('td,th');
        let csvrow = [];
        for (let j = 0; j < cols.length; j++) {
            csvrow.push(cols[j].innerText);
        }
        csv_data.push(csvrow.join(","));
    }
    csv_data = csv_data.join('\n');
    downloadCSVFile(csv_data);
}

export function downloadCSVFile(csv_data) {
    const CSVFile = new Blob([csv_data], {
        type: "text/csv"
    });
    let temp_link = document.createElement('a');
    temp_link.download = "XBullets.csv";
    let url = window.URL.createObjectURL(CSVFile);
    temp_link.href = url;
    temp_link.style.display = "none";
    document.body.appendChild(temp_link);
    temp_link.click();
    document.body.removeChild(temp_link);

}

export function searchTableX() {
    const colHead = document.getElementById("colHead")
    let inputx, tr, i, txtValue, a, table;
    inputx = document.getElementById("search");
    table = document.getElementById("dataTable");
    tr = table.getElementsByTagName('tr')
    for (i = 0; i < tr.length; i++) {
        a = tr[i];
        txtValue = a.textContent || a.innerText;
        if (txtValue.toUpperCase().indexOf(inputx.value.toUpperCase()) > -1) {
            tr[i].style.display = "";
            colHead.style.display = "";
        } else {
            tr[i].style.display = "none";
            colHead.style.display = "";
        }
    }
}


export function searchLogs() {
    let inputx, parentDiv, i, txtValue, a, res;
    inputx = document.getElementById("search");
    parentDiv = document.getElementById('accessLogs');
    // Get all <span> elements that are direct children of the parentDiv
    res = parentDiv.querySelectorAll(':scope > ul');

    for (i = 0; i < res.length; i++) {
        a = res[i];
        txtValue = a.textContent || a.innerText;
        if (txtValue.toUpperCase().indexOf(inputx.value.toUpperCase()) > -1) {
            res[i].style.display = "";
        } else {
            res[i].style.display = "none";
        }
    }
}

export function searchList() {
    let inputx, parentDiv, i, txtValue, a, res;
    inputx = document.getElementById("search");
    parentDiv = document.getElementById('listABQ');
    // Get all <span> elements that are direct children of the parentDiv
    res = parentDiv.querySelectorAll(':scope > ul');
    for (i = 0; i < res.length; i++) {
        a = res[i];
        txtValue = a.textContent || a.innerText;
        if (txtValue.toUpperCase().indexOf(inputx.value.toUpperCase()) > -1) {
            res[i].style.display = "";
        } else {
            res[i].style.display = "none";
        }
    }
}

export function searchDocs() {
    let inputx, parentDiv, i, txtValue, a, res;
    inputx = document.getElementById("search");
    parentDiv = document.getElementById('xdocs');
    // Get all <span> elements that are direct children of the parentDiv
    res = parentDiv.querySelectorAll(':scope > ul');
    for (i = 0; i < res.length; i++) {
        a = res[i];
        txtValue = a.textContent || a.innerText;
        if (txtValue.toUpperCase().indexOf(inputx.value.toUpperCase()) > -1) {
            res[i].style.display = "";
        } else {
            res[i].style.display = "none";
        }
    }
}

export function getDescByLabelName(list, val) {
    const result = list.filter((x) => x.label === val);
    if (!checkEmpty(result[0].desc)) {
        return result[0].desc
    }
}

export function getLabelByDescName(list, val) {
    const result = list.filter((x) => x.desc === val);
    if (!checkEmpty(result[0].label)) {
        return result[0].label
    }
}

export function makeid(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}

export function findMinMax(...numbers) {
    // Flatten the input array to handle nested arrays
    const flattenedNumbers = numbers.flat();

    // Filter out zero values and flatten any nested arrays
    const filteredNumbers = flattenedNumbers.filter(num => num !== 0 && !Array.isArray(num));

    // Ensure there are numbers left after filtering
    if (filteredNumbers.length === 0) {
        return [null, null]; // Return null values if no numbers are left
    }

    // Find the minimum and maximum values in the filtered array
    const min = Math.min(...filteredNumbers);
    const max = Math.max(...filteredNumbers);

    // Return the result as an array
    return [min, max];
}

export function spinner(load) {
    if (load === true) {
        document.getElementById('spinIt').style.display = 'block';
    }
    else {
        document.getElementById('spinIt').style.display = 'none';
    }
}

export function determineType(variable) {
    let type;

    if (Array.isArray(variable)) {
        type = 'array';
    } else if (variable === null) {
        type = 'null';
    } else {
        type = typeof variable;
    }

    return type;
}

export function randomIntBetween(min, max) { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min);
}

export function getColor(index) {
    let colors = ["#C08190", "#9ac1b4", "#95b5c3", "#ACA7CB", "#ec7d44", '#0088FE', '#00C49F', '#FFBB28', '#FF8042', 'red', 'pink', 'green', 'purple', 'blue'];
    return colors[index]
}

export function setDate() {
    const d = new Date();
    let text = d.toUTCString()
    return text
}

export function calcAvg(num1, num2, num3, num4, num5) {
    let total = Math.floor(parseInt(parseFloat(checkEmpty(num1) ? 0 : num1) + parseFloat(checkEmpty(num2) ? 0 : num2) + parseFloat(checkEmpty(num3) ? 0 : num3) + parseFloat(checkEmpty(num4) ? 0 : num4) + parseFloat(checkEmpty(num5) ? 0 : num5)) / 5)
    return total
}

export function calculateStandardDeviation(num1, num2, num3, num4, num5) {
    const numbers = [parseFloat(checkEmpty(num1) ? 0 : num1), parseFloat(checkEmpty(num2) ? 0 : num2), parseFloat(checkEmpty(num3) ? 0 : num3), parseFloat(checkEmpty(num4) ? 0 : num4), parseFloat(checkEmpty(num5) ? 0 : num5)];
    const mean = numbers.reduce((a, b) => a + b) / numbers.length;
    const variance = numbers.reduce((sum, num) => sum + Math.pow(num - mean, 2), 0) / numbers.length;
    const standardDeviation = Math.sqrt(variance);
    return parseFloat(standardDeviation.toFixed(1));
}

export function reviews(objx) {
    let obj = objx
    return obj.length
}

export function countStars(objx) {
    let val = ''
    let sum = 0
    if (objx.length > 0) {
        let obj = objx
        for (val of obj) {
            sum += val.count
        }
        return Math.round(sum / obj.length)
    } else {
    }
}

//charts

export const renderTooltipWithRange = ({ payload, content, ...rest }) => {
    //const newPayload = payload.filter((x) => x.dataKey !== "minMax");
    //return <Tooltip payload={newPayload} {...rest} />;
    return <Tooltip payload={payload} {...rest} />;
}

export const renderTooltipWithoutRange = ({ payload, content, ...rest }) => {
    const newPayload = payload.filter((x) => x.dataKey !== "minMax");
    return <Tooltip payload={newPayload} {...rest} />;
}

export const renderLegendWithoutRange = ({ payload, content, ...rest }) => {
    const newPayload = payload.filter((x) => x.dataKey !== "minMax");
    return <DefaultLegendContent payload={newPayload} {...rest} />;
}

export const getPath = (x, y, width, height) => {
    return `M${x},${y + height}C${x + width / 3},${y + height} ${x + width / 2},${y + height / 3}
  ${x + width / 2}, ${y}
  C${x + width / 2},${y + height / 3} ${x + (2 * width) / 3},${y + height} ${x + width}, ${y + height}
  Z`;
};

export const TriangleBar = (props) => {
    const { fill, x, y, width, height } = props;
    return <path d={getPath(x, y, width, height)} stroke="none" fill={fill} />;
};

export function getAuthErrorMessage(errorCode) {
    let errorMessage;
    switch (errorCode) {
        case 'auth/email-already-in-use':
            errorMessage = 'The provided email is already in use by an existing user. Each user must have a unique email.';
            break;
        case 'auth/email-already-exists':
            errorMessage = 'The provided email is already in use by an existing user. Each user must have a unique email.';
            break;
        case 'auth/phone-number-already-exists':
            errorMessage = 'The provided phoneNumber is already in use by an existing user. Each user must have a unique phoneNumber.';
            break;
        case 'auth/internal-error':
            errorMessage = 'The Authentication server encountered an unexpected error while trying to process the request. The error message should contain the response from the Authentication server containing additional information. If the error persists, please report the problem to Support.';
            break;
        case 'auth/invalid-email':
            errorMessage = 'The provided value for the email user property is invalid.';
            break;
        case 'auth/invalid-login-credentials':
            errorMessage = 'The email and password you entered do not match any account. Please check your credentials and try again.';
            break;
        case 'auth/invalid-password':
            errorMessage = 'The provided value for the password user property is invalid. It must be a string with at least six characters.';
            break;
        case 'auth/invalid-phone-number':
            errorMessage = 'The provided value for the phoneNumber is invalid. Please enter in the format: +12345678900 where +1 is the country code.';
            break;
        case 'auth/missing-password':
            errorMessage = 'You must provide a password to continue.';
            break;
        case 'auth/operation-not-allowed':
            errorMessage = 'Operation not allowed';
            break;
        case 'auth/weak-password':
            errorMessage = 'Weak password';
            break;
        case 'auth/user-not-found':
            errorMessage = 'There is no existing user record corresponding to the provided identifier.';
            break;
        case 'auth/wrong-password':
            errorMessage = 'Wrong password';
            break;
        default:
            errorMessage = 'An error occurred: ' + errorCode + '.';
            break;
    }
    return errorMessage;
}